import { useCreateEligibilitySelectionQuery } from "./useCreateEligibilitySelectionQuery";
import { EligibilitySelection, useStore } from "../../../contexts/StoreContext";

/**
 * Returns a function that creates an eligibility selection for a given application
 * if one was selected by the user during the eligibility flow.
 */
function useCreateEligibilitySelectionForApplication() {
  const { data: storeData } = useStore();
  const createEligibilitySelection = useCreateEligibilitySelectionQuery();

  async function createEligibilitySelectionForApplication(
    applicationId: string,
    eligibilitySelection?: EligibilitySelection
  ) {
    const selection = eligibilitySelection ?? storeData.eligibilitySelection;
    if (!selection) return;

    await createEligibilitySelection.mutateAsync({
      // @ts-expect-error openapi-typescript does not respect readonly payload fields
      body: {
        application: applicationId,
        criteria: selection.criteriaId,
        selected_option: selection.optionId,
        freeform_answer: selection.freeformAnswer,
      },
    });
  }

  return { createEligibilitySelectionForApplication };
}

export { useCreateEligibilitySelectionForApplication };
